
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCBBfajZ1ydLGfV6Vh9068jT2Y3UrZLDbs",
  authDomain: "ac-list-analytics.firebaseapp.com",
  projectId: "ac-list-analytics",
  storageBucket: "ac-list-analytics.appspot.com",
  messagingSenderId: "889856480589",
  appId: "1:889856480589:web:db4bb3a602edf996199304"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);dd
const db = getFirestore(app);

export const auth = getAuth(app);
export const storage = getStorage(app);

export default db;